var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"about-text-container"},[_c('h1',[_vm._v("杭州笑口杏信息科技有限公司")]),_c('p',[_vm._v("杭州笑口杏信息科技有限公司集研发、运营、渠道等资源优化为一体。杭州笑口杏信息科技有限公司为融合不同客户群体需求，特推出杭州笑口杏信息科技有限公司信息服务平台。目前平台开发了四大板块：广告策划、企业咨询、数字内容制作、系统平台搭建等，可以满足不同用户群体发布产品信息的需求。用户注册登录后，可以发布自己的产品信息，我们平台将为其做好精准推流和交易撮合服务，以便客户对接到合适的业务。")])])])
}]

export { render, staticRenderFns }